import { render, staticRenderFns } from "./RadarCard.vue?vue&type=template&id=f8cbe88c"
import script from "./RadarCard.vue?vue&type=script&lang=js"
export * from "./RadarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports